import React, { FormEvent, useState } from 'react';
import { Button, Card, Col, Container, Row, Modal, Image } from 'react-bootstrap';
import { fetchDealerTiers, useDealerTiers } from '../Store/entities/organizations/dealerTiers';
import { DealerTier } from '../powershadesApiTypes';
import { FaEye, FaEdit, FaTrash, FaPlus, FaPhotoVideo } from 'react-icons/fa';
import apiCalls from '../PowerShadesAPIFunctions';
import { UsePortalDispatch } from '../Store';

const DealerTiersContent = () => {
    const {
        tiers,
        updateTier,
        deleteTier,
        createTier
    } = useDealerTiers();

    const [showPortrait, setShowPortrait] = useState(false);
    const [editFormData, setEditFormData] = useState<Partial<DealerTier>>({});
    const [createFormData, setCreateFormData] = useState<Partial<DealerTier>>({});
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isPortraitModalOpen, setIsPortraitModalOpen] = useState(false);

    const dispatch = UsePortalDispatch();
    const [photoToUpload, setPhotoToUpload] = useState<File | null>(null);

    const [selectedTierId, setSelectedTierId] = useState<number | null>(null);
    const onChange = (e: FormEvent<HTMLInputElement>) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (file) {
            setPhotoToUpload(file);
        }
    }

    const handleUploadPortrait = (file: File) => {

        const formData = new FormData();
        formData.append('file', file);
        formData.append('tierId', selectedTierId!.toString());
        formData.append('fileName', file.name);
        formData.append('fileType', file.type);
        formData.append('fileSize', file.size.toString());
        formData.append('fileLastModified', file.lastModified.toString());

        apiCalls.updateDealerTierPortrait(selectedTierId!, formData)
            .then((response) => {
                if (response.status === 200) {
                    // Handle success
                    console.log('Portrait u pdated successfully');
                } else {
                    // Handle error
                    console.error('Error updating portrait');
                }
            })
            .catch((error) => {
                // Handle error
                console.error('Error updating portrait', error);
            });

        dispatch(fetchDealerTiers());
    }


    const openPortraitModal = (tier: DealerTier) => {
        setIsPortraitModalOpen(true);
        setSelectedTierId(tier.id);
    }
    const handleViewClick = (tierId: number) => {
        setSelectedTierId(tierId);
        setIsViewModalOpen(true);
    };

    const handleEditClick = (tierId: number) => {
        setSelectedTierId(tierId);
        setIsEditModalOpen(true);
        setEditFormData(tiers.find((tier) => tier.id === tierId) ?? {});
    };

    const handleDeleteClick = (tierId: number) => {
        setSelectedTierId(tierId);
        setIsDeleteModalOpen(true);
    };

    const handleCreateClick = () => {
        setCreateFormData({});
        setIsCreateModalOpen(true);
    };

    const handlePortraitClick = (tierId: number) => {
        setSelectedTierId(tierId);
        setShowPortrait(true);
    };

    const handleEditSubmit = () => {
        if (selectedTier) {
            updateTier(selectedTier.id, editFormData);
            setIsEditModalOpen(false);
        }
    };

    const handleCreateSubmit = () => {
        createTier(createFormData);
        setIsCreateModalOpen(false);
    };

    const handleDeleteConfirm = () => {
        if (selectedTierId) {
            deleteTier(selectedTierId);
            setIsDeleteModalOpen(false);
        }
    };

    const selectedTier = tiers.find((tier) => tier.id === selectedTierId);

    const imageUrl = `${process.env.BACKEND_ROOT}/api/DealerTiers/${selectedTierId}/Portrait`;

    return (
        <Container fluid>
            <Row className="mb-3">
                <Col>
                    <Button variant="primary" onClick={handleCreateClick}>
                        <FaPlus className="me-2" />
                        Add New Dealer Tier
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Card>
                        <Card.Header>
                            <h3>Dealer Tiers</h3>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Portrait</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tiers.map((tier) => (
                                            <tr key={tier.id}>
                                                <td>{tier.id}</td>
                                                <td>{tier.name}</td>
                                                <td>{tier.description}</td>
                                                <td>
                                                    {tier.portrait_location && (
                                                        <Button
                                                            variant="link"
                                                            onClick={() => handlePortraitClick(tier.id)}
                                                        >
                                                            View Portrait
                                                        </Button>
                                                    )}
                                                </td>
                                                <td>
                                                    <Button
                                                        variant="info"
                                                        size="sm"
                                                        className="me-2"
                                                        onClick={() => handleViewClick(tier.id)}
                                                    >
                                                        <FaEye />
                                                    </Button>
                                                    <Button
                                                        variant="warning"
                                                        size="sm"
                                                        className="me-2"
                                                        onClick={() => handleEditClick(tier.id)}
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    <Button
                                                        variant="secondary"
                                                        size="sm"
                                                        className="me-2"
                                                        onClick={() => openPortraitModal(tier)}
                                                    >
                                                        <FaPhotoVideo />
                                                    </Button>
                                                    <Button
                                                        variant="danger"
                                                        size="sm"
                                                        onClick={() => handleDeleteClick(tier.id)}
                                                    >
                                                        <FaTrash />
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Portrait Modal */}
            <Modal show={showPortrait} onHide={() => setShowPortrait(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Dealer Tier Portrait</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedTierId && (
                        <Image src={imageUrl} fluid />
                    )}
                </Modal.Body>
            </Modal>

            {/* View Modal */}
            <Modal show={isViewModalOpen} onHide={() => setIsViewModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>View Dealer Tier</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedTier && (
                        <div className="d-flex">
                            <div className="me-4">
                                {selectedTier.portrait_location && (
                                    <Image src={imageUrl} style={{ maxWidth: '200px' }} />
                                )}
                            </div>
                            <div>
                                <h4>{selectedTier.name}</h4>
                                <p>{selectedTier.description}</p>
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            {/* Edit Modal */}
            <Modal show={isEditModalOpen} onHide={() => setIsEditModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Dealer Tier</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editFormData.name || ''}
                                onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                                className="form-control"
                                value={editFormData.description || ''}
                                onChange={(e) => setEditFormData({ ...editFormData, description: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Picture URL</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editFormData.portrait_location || ''}
                                onChange={(e) => setEditFormData({ ...editFormData, portrait_location: e.target.value })}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsEditModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleEditSubmit}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={isDeleteModalOpen} onHide={() => setIsDeleteModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this dealer tier?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsDeleteModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={() => handleDeleteConfirm()}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Create Modal */}
            <Modal show={isCreateModalOpen} onHide={() => setIsCreateModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create New Dealer Tier</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={createFormData.name || ''}
                                onChange={(e) => setCreateFormData({ ...createFormData, name: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Description</label>
                            <textarea
                                className="form-control"
                                value={createFormData.description || ''}
                                onChange={(e) => setCreateFormData({ ...createFormData, description: e.target.value })}
                            />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Picture URL</label>
                            <input
                                type="text"
                                className="form-control"
                                value={createFormData.portrait_location || ''}
                                onChange={(e) => setCreateFormData({ ...createFormData, portrait_location: e.target.value })}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsCreateModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleCreateSubmit}>
                        Create
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Update Portriat Modal 
                The modal has the tier name as the title, the current portrait on the left and the method to upload a new portrait on the right.
                The modal footer has the cancel and save buttons.
                The save button will call the handleUploadPortrait function to upload the new portrait.
                The cancel button will close the modal.
            */}
            <Modal show={isPortraitModalOpen} onHide={() => setIsPortraitModalOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Portrait</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedTier && (
                        <div className="d-flex">
                            <div className="me-4">
                                {selectedTier.portrait_location && (
                                    <Card className={`h-100 ${'border border-2 border-primary'}`}>
                                        <Card.Img variant="top" src={imageUrl} />
                                    </Card>
                                )}
                            </div>
                            <div>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={onChange}
                                    onSubmit={(e) => onChange(e)}
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setIsPortraitModalOpen(false)}>
                        Cancel
                    </Button>
                    <Button disabled={!photoToUpload} variant="primary" onClick={() => handleUploadPortrait(photoToUpload!)}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>



        </Container>
    );
};

export default DealerTiersContent; 